/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RadiologyEhrApi } from '../api/radiology-ehr.api';
import { switchMap, map } from 'rxjs/operators';
import { RadiologyEhrData, RadiologyEhr } from '../../../interfaces/ehr/radiology-ehr';


@Injectable()
export class RadiologyEhrService extends RadiologyEhrData {

  constructor(private api: RadiologyEhrApi) {
    super();
  }



  list(url: string): Observable<RadiologyEhr[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<RadiologyEhr>{
      return this.api.getById(url);
  }
  get(url:string): Observable<RadiologyEhr>{
    return this.api.get(url);
}

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

  createWithProgress(url: string, data:any): Observable<any> {
    return this.api.addWithProgress(url,data);
  }

  update(url: string, data:RadiologyEhr): Observable<RadiologyEhr> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

 
}
